export const spacing = {
  xs: 4,
  s: 8,
  m: 16,
  l: 24,
  xl: 32,
};

export const radius = {
  button: 4,
  card: 12,
  contextMenu: 8,
  input: 4,
  tagSmall: 4,
  tagMedium: 6,
  tagLarge: 8,
  avatarSmall: 4,
  avatarLarge: 8,
  avatarCircle: 999,
};

/** Primitive radius scale. Mirrors Figma "Scale / radius/*" variables. */
export const radiusScale = {
  "25": 2,
  "50": 4,
  "75": 6,
  "100": 8,
  "150": 12,
  "200": 16,
  "250": 20,
  "300": 24,
  "350": 28,
  "400": 32,
  "999": 999,
} as const;

/** Primitive border-width scale. Mirrors Figma "Scale / stroke/*" variables. */
export const stroke = {
  "1": 1,
  "2": 2,
  "3": 3,
} as const;
